import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import Loading from "./Loading";

const CustomRedirect = () => {
  const { keyGuid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const resolvePriority = async () => {
      try {
        const res = await api.resolvePriority(keyGuid);
        navigate(`/${res}`, { replace: true });
      } catch (err) {
        navigate("/", { replace: true });
      }
    };

    resolvePriority();
  }, [keyGuid, navigate]);

  return loading ? <Loading text="Ładowanie podglądu..." /> : null;
};

export default CustomRedirect;
